import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  getAccountingReportDetails,
  getReports,
  getSaledDetails,
} from "../../redux/actions/api/apiAction";
import { BalanceReportDetails } from "../../views/pages/gymPortion/reports/balanceAccoutDetailsTable";
import { AccountingDetails } from "../../views/pages/gymPortion/reports/accountingDetails";
import { ReportExportButton } from "../../views/pages/gymPortion/reports/exportButton";
import { ExportButton } from "../../views/pages/gymPortion/reports/exportDetailsButton";
import {
  setBalanceDetailsLimit,
  setBalanceDetailsPage,
  setReportLimit,
  setReportPage,
} from "../../redux/actions/reports/reportsAction";
export const AccountingModal = ({ toggle, category }) => {
  const dispatch = useDispatch();
  const { detailsPage, detailsLimit, showAccountingDetails } = useSelector(
    (state) => state.report
  );
  const { gym } = useSelector((state) => state.gym);
  const [loading, setIsLoading] = useState(true);
  const { accountingDetails, reportQuery } = useSelector(
    (state) => state.report
  );
  const getData = async () => {
    dispatch(
      getAccountingReportDetails({
        limit: detailsLimit,
        page: detailsPage,
        query: {
          ...reportQuery,
          category,
        },
      })
    );
    setIsLoading(false);
  };
  React.useEffect(() => {
    getData();
  }, [detailsPage, detailsLimit, category, reportQuery]);

  React.useEffect(() => {
    return () => {
      dispatch(setBalanceDetailsPage(1));
      dispatch(setBalanceDetailsLimit(10));
      dispatch(setReportLimit(10));
      dispatch(setReportPage(1));
    };
  }, []);
  return (
    <>
      <Modal
        isOpen={showAccountingDetails[category]}
        toggle={toggle}
        centered={true}
        size="lg"
        className="large-pop adding-popup "
      >
        <ModalHeader toggle={toggle}>Accounting Entry Details</ModalHeader>
        <ModalBody>
          {/* {(login.loginUser.role === "STAFF" && !permissions["S-EXP"]) ||
      (subAdminType === "SUB_ADMIN" && !subAdminPermissions["S-EXP"]) ? null : ( */}
          <Col md={12} className="d-flex justify-content-end">
            <ExportButton
              type={"details"}
              data={accountingDetails?.data}
              currentTab={category}
              from={reportQuery?.startDate}
              to={reportQuery?.endDate}
              gymName={gym?.user.name}
            />
          </Col>
          {/* )} */}
          <AccountingDetails category={category}/>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
